Bingo.DemandSummaryNotificationsTrigger = {};

Bingo.DemandSummaryNotificationsTrigger.init = () => {
    $('#js-demandSummary__notificationSwitch').on('click', 'a.js-dropdownMenu__item', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const notificationIcon = $('.js-demandSummary__notificationIcon');
        const notificationsSwitch = $(this).closest('#js-demandSummary__notificationSwitch');
        const typeId = $(this).data('id');

        // hide all notification icons
        notificationIcon.hide();

        // show selected notification icon
        $(`.js-demandSummary__notificationIcon[data-id='${typeId}']`).show();

        // change value in hidden input element to selected notification type
        $('#js-demandSummary__notificationsTypeInput').val(typeId);

        // hide dropdown menu
        notificationsSwitch.dropdown('toggle');

        return false;
    });
};
